module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//modal-bg.png?v=83e8e04f";